import { createWikifolioDetailBreadcrumbSchema } from "src/constants/structured-data";
import { JsonLdScript } from "./json-ld-script";

type IWikifolioDetailBreadcrumbSchemaProps = {
    canonicalUrl: string;
    dict: { home: string; allWikifolios: string };
    wikifolioName: string;
};

export const WikifolioDetailBreadcrumbSchema = ({ canonicalUrl, dict, wikifolioName }: IWikifolioDetailBreadcrumbSchemaProps) => (
    <JsonLdScript schema={createWikifolioDetailBreadcrumbSchema(canonicalUrl, dict, wikifolioName)} />
);
